/* eslint-disable */
export enum AppRoute {
  poReceiveLandingPage="/acimapo/poreceive",
  pendingPo='/acimapo/poreceive/details/:ponumber'
}
